import { render, staticRenderFns } from "./VeImageBlockSettings.vue?vue&type=template&id=2fa2035e"
import script from "./VeImageBlockSettings.vue?vue&type=script&lang=js"
export * from "./VeImageBlockSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports